import { render, staticRenderFns } from "./Mutterkuh-Card.vue?vue&type=template&id=8cfe2e28&scoped=true&"
import script from "./Mutterkuh-Card.vue?vue&type=script&lang=js&"
export * from "./Mutterkuh-Card.vue?vue&type=script&lang=js&"
import style0 from "./Mutterkuh-Card.vue?vue&type=style&index=0&id=8cfe2e28&style=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cfe2e28",
  null
  
)

export default component.exports